import * as idEndpoints from './id';
import { root, id } from './rtmp';

export const rtmp = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
